/// <reference path="WebComponent.ts" />

namespace Sintra {

	// const WizardNavButtonStyle = document.createElement("style");
	// WizardNavButtonStyle.innerHTML = `
	// 	.wizard-nav-button {
	// 		cursor: pointer;
	// 		user-select: none;
	// 		display: inline-block;
	// 		padding: 0;
	// 		width: 260px;
	// 		position: relative;
	// 		margin: 10px;
	// 		text-align: center;
	// 		position: relative;
	// 	}

	// 	.wizard-nav-button[data-appearance="text-only"] {
	// 		border: none;
	// 		border-radius: 0;
	// 		padding: 20px;
	// 		background: #003165;
	// 		color: #fff;
	// 		border-radius: 100vw;
	// 	}
	// 	.wizard-nav-button[data-appearance="text-only"] > .image-border {
	// 		display: none;
	// 	}
	// 	.wizard-nav-button[data-appearance="text-only"] [template-part="text"] {
	// 		font-weight: 700;
	// 		font-size: 16px;
	// 		line-height: 16px;
	// 		text-transform: uppercase;
	// 	}


	// 	.wizard-nav-button[data-appearance="image-fit"] {
	// 		border: none;
	// 		border-radius: 0;
	// 	}
	// 	.wizard-nav-button[data-appearance="image-fit"] > .image-border {
	// 		border-radius: 4px;
	// 		overflow: hidden;
	// 		border: 1px solid #4A4A4A;
	// 		margin-bottom: 20px;
	// 	}
	// 	.wizard-nav-button[data-appearance="image-fit"] [template-part="image"] {
	// 		display: block;
	// 		width: 100%;
	// 	}
	// 	.wizard-nav-button[data-appearance="image-fit"] [template-part="text"] {
	// 		font-weight: 700;
	// 		font-size: 16px;
	// 		line-height: 20px;
	// 	}

	// 	.wizard-nav-button[data-appearance="icon-centered"] {
	// 		border-radius: 4px;
	// 		overflow: hidden;
	// 		border: 1px solid #4A4A4A;
	// 		padding-top: 35px;
	// 		padding-bottom: 20px;
	// 	}
	// 	.wizard-nav-button[data-appearance="icon-centered"] > .image-border {
	// 		border-radius: 0;
	// 		overflow: hidden;
	// 		border: none;
	// 		display: inline-block;
	// 		margin-bottom: 30px;
	// 	}
	// 	.wizard-nav-button[data-appearance="icon-centered"] [template-part="image"] {
	// 		display: block;
	// 	}
	// 	.wizard-nav-button[data-appearance="icon-centered"] [template-part="text"] {
	// 		font-weight: 700;
	// 		font-size: 16px;
	// 		line-height: 20px;
	// 	}`;
	//document.head.appendChild(WizardNavButtonStyle);


	const WizardNavButtonTemplate = document.createElement("template");
	WizardNavButtonTemplate.innerHTML = /*html*/ `
		<div class="image-border">
			<img template-part="image" />
		</div>
		<div template-part="text"></div>
	`;

	export class WizardNavButton extends WebComponent {

		private _image: string;
		private _text: string;
		private _secondaryText: string;
		private _appearance: string;
		private _targetStep: string;
		private _complete: boolean;
		private _setters: DynamicObject;
		private _isSelected: boolean;
		private _isRejected: boolean;

		private _textElement: HTMLElement;
		private _secondaryTextElement: HTMLElement;
		private _imageElement: HTMLImageElement;


		constructor(templateSource?: TemplateSource) {
			super("div", templateSource || WizardNavButtonTemplate);

			this._setters = {};

			this.htmlElement.classList.add("wizard-nav-button");
			this.htmlElement.addEventListener("click", this._onClick.bind(this));
		}

		protected onApplyTemplate(templateRoot: HTMLElement) {
			this._imageElement = this.getTemplatePart("image");
			this._textElement = this.getTemplatePart("text");
			this._secondaryTextElement = this.getTemplatePart("secondaryText");

			this._setTextProperty(this._text);
			this._setSecondaryTextProperty(this._secondaryText);
			this._setImageProperty(this._image);
		}

		private _setTextProperty(value: string) {
			if (!this._textElement) {
				return;
			}
			if (value === undefined) {
				this._textElement.innerHTML = "";
			}
			else {
				this._textElement.innerText = value;
			}
		}

		private _setSecondaryTextProperty(value: string) {
			if (!this._secondaryTextElement) {
				return;
			}
			if (value === undefined) {
				this._secondaryTextElement.innerHTML = "";
			}
			else {
				this._secondaryTextElement.innerText = value;
			}
		}

		private _setImageProperty(value: string) {
			if (!this._imageElement) {
				return;
			}
			if (value === undefined) {
				this._imageElement.src = "";
			}
			else {
				this._imageElement.src = value;
			}
		}


		private _onClick(e: Event) {
			e.stopPropagation();
			this.htmlElement.dispatchEvent(new CustomEvent("nav-click", {
				detail: {
					sender: this,
					complete: this._complete,
					targetStep: this._targetStep,
					setters: this._setters
				}
			}));
		}

		private _onTextChanged() {
			if (!this._textElement) {
				return;
			}
			this._setTextProperty(this._text);
		}

		private _onSecondaryTextChanged() {
			if (!this._secondaryTextElement) {
				return;
			}
			this._setSecondaryTextProperty(this._secondaryText);
		}

		private _onImageChanged() {
			if (!this._imageElement) {
				return;
			}
			this._setImageProperty(this._image);
		}

		private _onAppearanceChanged() {
			switch (this._appearance) {
				case "image-fit":
				case "icon-centered":
				case "text-only":
				{
					this.htmlElement.dataset.appearance = this._appearance;
					break;
				}
				default:
				{
					this.htmlElement.dataset.appearance = "text-only";
					break;
				}
			}
		}

		private _setSelectedState(selected: boolean) {
			if (selected) {
				// set "selected"
				this.htmlElement.classList.add("selected");
				this.htmlElement.dataset.isSelected = "true";
				// unset "rejected"
				this.htmlElement.classList.remove("rejected");
				this.htmlElement.removeAttribute("data-is-rejected");
			}
			else {
				// unset "selected"
				this.htmlElement.classList.remove("selected");
				this.htmlElement.removeAttribute("data-is-selected");
			}
		}

		private _setRejectedState(rejected: boolean) {
			if (rejected) {
				// set "rejected"
				this.htmlElement.classList.add("rejected");
				this.htmlElement.dataset.isRejected = "true";
				// unset "selected"
				this.htmlElement.classList.remove("selected");
				this.htmlElement.removeAttribute("data-is-selected");
			}
			else {
				// unset "rejected"
				this.htmlElement.classList.remove("rejected");
				this.htmlElement.removeAttribute("data-is-rejected");
			}
		}

		// private _setNormalState() {
		// 	// unset "selected"
		// 	this.htmlElement.classList.remove("selected");
		// 	this.htmlElement.removeAttribute("data-is-selected");
		// 	// unset "rejected"
		// 	this.htmlElement.classList.remove("rejected");
		// 	this.htmlElement.removeAttribute("data-is-rejected");
		// }

		private _onIsSelectedChanged() {
			this._setSelectedState(this._isSelected);
		}

		private _onIsRejectedChanged() {
			this._setRejectedState(this._isRejected);
		}


		get text() { return this._text; }
		set text(v) {
			if (this._text !== v) {
				this._text = v;
				this._onTextChanged();
			}
		}

		get secondaryText() { return this._secondaryText; }
		set secondaryText(v) {
			if (this._secondaryText !== v) {
				this._secondaryText = v;
				this._onSecondaryTextChanged();
			}
		}

		get image() { return this._image; }
		set image(v) {
			if (this._image !== v) {
				this._image = v;
				this._onImageChanged();
			}
		}

		get appearance() { return this._appearance; }
		set appearance(v) {
			if (this._appearance !== v) {
				this._appearance = v;
				this._onAppearanceChanged();
			}
		}

		get targetStep() { return this._targetStep; }
		set targetStep(v) { this._targetStep = v; }

		get complete() { return this._complete; }
		set complete(v) { this._complete = !!v; }

		get setters() { return this._setters; }

		get isSelected() { return this._isSelected; }
		set isSelected(v) {
			if (this._isSelected !== v) {
				this._isSelected = v;
				this._onIsSelectedChanged();
			}
		}

		get isRejected() { return this._isRejected; }
		set isRejected(v) {
			if (this._isRejected !== v) {
				this._isRejected = v;
				this._onIsRejectedChanged();
			}
		}
	}
}